module.exports = __webpack_public_path__ + "static/media/carroMoto.e8d16b45.png";